<template>
  <div
      class="modal"
      tabindex="-1"
      role="dialog"
      v-bind:id="'shape_settings_modal_' + shapeRP.id"
      data-bs-backdrop="false"
      data-bs-keyboard="false"
  >
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Vorm instellingen {{ shapeRP.name }}</h5>

          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <ul class="nav nav-tabs" role="tablist" v-bind:id="'ssm_' + shapeRP.id + '_tabbar-tablist'">
            <li class="nav-item">
              <a
                  class="nav-link active"
                  v-bind:id="'ssm_' + shapeRP.id + '_tabbar_general-tab'"
                  role="tab"
                  data-bs-toggle="tab"
                  v-bind:aria-controls="'ssm_' + shapeRP.id + '_tabbar_general'"
                  v-bind:data-bs-target="'#ssm_' + shapeRP.id + '_tabbar_general'"
                  aria-selected="true"
              >Algemeen</a>
            </li>
          </ul>
          <div class="tab-content">
            <div
                class="tab-pane show active"
                v-bind:id="'ssm_' + shapeRP.id + '_tabbar_general'"
                role="tabpanel"
                v-bind:aria-labelledby="'ssm_' + shapeRP.id + '_tabbar_general-tab'"
            >
              <div class="form-group">
                <label v-bind:for="'ssm_' + shapeRP.id + '_name'" class="form-label">Vorm naam</label>
                <input type="text" class="form-control" v-bind:id="'ssm_' + shapeRP.id + '_name'" placeholder="Typ een naam..." v-bind:value="shapeRP.name">
              </div>

              <div class="form-group">
                <label v-bind:id="'ssm_' + shapeRP.id + '_color_label'" class="form-label">Kleur</label>

                <div class="input-group">
                  <div
                      v-show="!shapeRP.isCustomColor"
                      v-bind:class="'form-control ' + (shapeRP.isCustomColor ? '' : 'd-flex') + ' flex-column justify-content-center cursor-pointer'"
                      v-bind:id="'ssm_' + shapeRP.id + '_color_value'"
                  >
                    <div class="color-value" v-bind:style="'background-color: ' + shapeRP.color"></div>
                  </div>
                  <input
                    v-if="shapeRP.isCustomColor"
                    class="form-control h-auto"
                    type="color"
                    v-bind:id="'ssm_' + shapeRP.id + '_custom_color_value'"
                    v-bind:value="shapeRP.color"
                    v-on:change="changeColor($event.target.value)"
                  />
                  <button
                      type="button"
                      class="btn btn-outline-secondary dropdown-toggle dropdown-toggle-split"
                      data-bs-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      v-bind:id="'ssm_' + shapeRP.id + '_color_toggle'"
                  >
                    <span class="visually-hidden">Toggle Dropdown</span>
                  </button>
                  <div class="dropdown-menu dropdown-menu-end">
                    <button
                        v-for="color of colors"
                        class="dropdown-item color-option"
                        type="button"
                        v-bind:style="'background-color: ' + color"
                        v-on:click="changeColor(color)"
                    ></button>
                    <button
                        class="dropdown-item"
                        type="button"
                        v-on:click="customColor()"
                    >Anders...</button>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="form-check">
                  <input class="form-check-input" v-bind:id="'ssm_' + shapeRP.id + '_fill_interior'" type="checkbox" value="1" v-bind:checked="shapeRP.fillInterior" v-on:change="changeFillInterior($event.target.checked)">
                  <label class="form-check-label" v-bind:for="'ssm_' + shapeRP.id + '_fill_interior'">Opvullen</label>
                </div>
              </div>

              <div class="form-group">
                <label v-bind:for="'ssm_' + shapeRP.id + '_line_style_type'" class="form-label">Lijn stijl</label>
                <select class="form-select" v-bind:id="'ssm_' + shapeRP.id + '_line_style_type'">
                  <option
                      v-for="[type, label] in [['none', 'Geen'], ['solid', 'Continu'], ['dashed', 'Gestreept'], ['dotted', 'Gestipt']]"
                      :key="type"
                      v-bind:value="type"
                      v-bind:selected="shapeRP.lineStyleType === type"
                  >{{ label }}</option>
                </select>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Container from "../Main/Container";
import $ from "jquery";
import Shape from "../Main/Shape.js";
import ShapeChangeNameAction from "../ActionHistory/ShapeChangeNameAction.js";
import ShapeChangeColorAction from "../ActionHistory/ShapeChangeColorAction.js";
import ShapeChangeLineStyleTypeAction from "../ActionHistory/ShapeChangeLineStyleTypeAction.js";
import ShapeChangeFillInteriorAction from "../ActionHistory/ShapeChangeFillInteriorAction.js";
import {Dropdown} from "bootstrap";
import {bsModal} from "../Util/vueFunctions";
import {asArray} from "ol/color";
import {rgbaToHex} from "../Util/functions";

export default {
  props: {
    listenId: String,
    shape: Shape,
  },
  data () {
    $(() => {
      const shape = this.shape;

      $('#' + this.listenId).on('click', () => {
        bsModal('#shape_settings_modal_' + shape.id).show();
      });

      $('#ssm_' + shape.id + '_name').on('change keyup input blur', function() {
        const newName = $(this).val();
        if(newName !== shape.name) {
          shape.shapeCollection.userInterface.actionHistory.addAction(new ShapeChangeNameAction(shape, newName));
        }
      });

      const $toggle = $('#ssm_' + shape.id + '_color_toggle');
      let colorOpen = false;
      $toggle.parent()[0].addEventListener('show.bs.dropdown', () => colorOpen = true);
      $toggle.parent()[0].addEventListener('hidden.bs.dropdown', () => colorOpen = false);
      $('#ssm_' + shape.id + '_color_label, #ssm_' + shape.id + '_color_value').on('click', () => {
        if (!colorOpen) {
          setTimeout(() => Dropdown.getOrCreateInstance($toggle[0]).show());
        }
      });

      $('#ssm_' + shape.id + '_line_style_type').on('change', function() {
        const newVal = $(this).val();
        const oldLineStyleType = shape.lineStyleType;
        if(newVal !== oldLineStyleType) {
          shape.shapeCollection.userInterface.actionHistory.addAction(new ShapeChangeLineStyleTypeAction(shape, newVal));
        }
      });

    });

    return {
      container: Container,
      shapeRP: this.shape.reactiveProps,
      colors: this.shape.shapeCollection.userInterface.colors,
    };
  },
  watch: {

  },
  computed: {

  },
  methods: {
    changeColor(newColor) {
      if(newColor !== this.shape.color) {
        this.shape.shapeCollection.userInterface.actionHistory.addAction(new ShapeChangeColorAction(this.shape, newColor));
      }
    },
    customColor() {
      const newColor = rgbaToHex(asArray(this.shape.color));

      if(newColor !== this.shape.color) {
        this.shape.shapeCollection.userInterface.actionHistory.addAction(new ShapeChangeColorAction(this.shape, newColor));
      }

      setTimeout(() => {
        document.getElementById('ssm_' + this.shape.id + '_custom_color_value').click();
      });
    },
    changeFillInterior(newFillInterior) {
      if(newFillInterior !== this.shape.getFillInterior()) {
        this.shape.shapeCollection.userInterface.actionHistory.addAction(new ShapeChangeFillInteriorAction(this.shape, newFillInterior));
      }
    },
  }
};
</script>

<style scoped>
.color-option {
  height: 1rem;
}

.color-value {
  height: .25rem;
}
</style>
